import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getArrivalDetail(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getListArrivals(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    changeStatusArrival(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    cancelArrival(path: string, params: any): Promise<any> {
        return super.putPromise(path, params)
    }
})()